;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import axiosInstance from '../utils/axios';
import { event } from '../utils/gtag';

export const uploadApplication = async (jobApplication) => {
  const app = process.env.NEXT_PUBLIC_APP;
  const { data } = await axiosInstance.post(`/apply`, jobApplication);
  event({
    action: 'apply',
    category: app || 'synergiejobs.be',
    label: '',
    value: jobApplication.job,
  });

  return data;
};
